import { render, staticRenderFns } from "./EditMembro.vue?vue&type=template&id=dc2045c4&"
import script from "./EditMembro.vue?vue&type=script&lang=js&"
export * from "./EditMembro.vue?vue&type=script&lang=js&"
import style0 from "./EditMembro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports